
import BaseFirebaseRepository from '../../../components/repository/BaseFirebaseRepository';

const instances = {}
const defaultInstanceKey = Math.random()
export default class VariationRepository extends BaseFirebaseRepository {
    // Indicate that this repository use API instead of Firebase
    isUseAPI = true

    /**
     * @param {*} app
     * @return {VariationRepository}
     */
    static getInstance(app) {
        if (app == null) {
            // By default, use instance created from main App
            app = VariationRepository.context || defaultInstanceKey
        }
        if (app != null && instances[app] == null) {
            // Create a new instance
            instances[app] = new VariationRepository(app)
        }
        return instances[app]
    }
    getRef = () => {
        return null
    }
    getSingleRef = () => {
        // This repository uses API to load instead of Firebase, so this
        // function is not called
        return null
    }
    getBaseObject = () => {
        return {}
    }
    getApiBaseUrl = (id) => {
        if (id == 'all') {
            return `/merchant/api/variation`
        }
        else {
            return `/merchant/api/variation/%id%`.replace('%id%', id)
        }
    }
    getReloadEventKey = () => {
        return "variation_version.changed"
    }
    /**
     * Parse raw API response before perform any logic
     * @returns {Object}
     */
    parseRawApiResponse = (rawResponse) => {
        if (rawResponse) {
            if (!Array.isArray(rawResponse)) {
                return [rawResponse]
            }
            else {
                return rawResponse
            }
        }
        return []
    }

    delete = (v, callback) => {
        $.ajax({
            url     : this.getApiBaseUrl(v.id) + "/delete",
            type    : 'post',
            success : (res) => {
                console.log(res)
            }
        })
        .always(callback)
    }
}
